export default function ArchivedReportInstanceController(
  $scope,
  $rootScope,
  loaderService,
  reportsDataService,
  reportsSharedModelService,
  ssDialogService,
  alerts,
) {
  const vm = this;

  vm.handleExpand = _handleExpand;

  vm.handleDeleteReport = _handleDeleteReport;

  _activate();

  /** ********************************************
   * Event Handlers
   */

  function _handleExpand() {
    vm.isExpanded = !vm.isExpanded;
  }

  function _handleDeleteReport() {
    loaderService.showViewLoader = true;
    return reportsDataService.deleteArchivedReportInstance(vm.reportInstance.reportInstanceArchiveId).then((success) => {
      loaderService.showViewLoader = false;
      if (success) {
        const _uniqueId = vm.reportInstance.familyId + "-" + vm.reportInstance.reportId;
        $rootScope.$broadcast(`reports.archivedReports.reportType.archivedReportInstanceDeleted`, 
          {reportTypeId: _uniqueId, reportInstance: vm.reportInstance } ); // eslint-disable-line max-len
        alerts.success('The Report Instance has been successfully deleted.');
      } else {
        alerts.error('An error occurred while deleting the Report Instance.');
      }
    });
  }

  /** ********************************************
   * Private Functions
   */

  function _activate() {
    vm.canExpand = false;
    vm.isExpanded = false;

    if (vm.reportInstance.reportInstanceComments !== null) {
      vm.canExpand = true;
    }

    _initEventListeners();
  }

  function _initEventListeners() {
    $scope.$on('refreshReportStatus', (event, opt) => {
      if (opt.reportInstanceId === vm.reportInstance.reportInstanceId) {
        _updateReportStatus();
        _loadComments();
      }
    });

    $scope.$on('refreshReportInstanceComments', (event, opt) => {
      if (opt.reportInstanceId === vm.reportInstance.reportInstanceId) {
        _loadComments();
      }
    });
  }

  function _updateReportStatus() {
    loaderService.showViewLoader = true;
    return reportsDataService.getReportInstance(vm.reportInstance.reportInstanceId).then((response) => {
      loaderService.showViewLoader = false;
      vm.reportInstance.acknowledgeStatusId = response.data.acknowledgeStatusId;
      vm.reportInstance.acknowledgeStatus = response.data.acknowledgeStatus;
    });
  }

  function _loadComments() {
    loaderService.showViewLoader = true;
    return reportsDataService.getReportInstanceNotes(vm.reportInstance.reportInstanceId).then((response) => {
      loaderService.showViewLoader = false;
      vm.reportInstance.reportInstanceComments = response.data;

      if (vm.reportInstance.reportInstanceComments !== null) {
        vm.canExpand = true;
      } else {
        vm.canExpand = false;
      }
    });
  }
}

ArchivedReportInstanceController.$inject = [
  '$scope',
  '$rootScope',
  'loaderService',
  'reportsDataService',
  'reportsSharedModelService',
  'ssDialogService',
  'alerts',
];
